import HttpRequest from "@api/httpRequest";
import {RequestData} from "@models/axios";
import getPropByString from "@utils/get";

const getUrl = (): string => {
    return `/tickets`
};

function api() {
    return {
        getList: (data: RequestData) => {
            const {params = {}} = data;
            return HttpRequest.get(getUrl(), {
                params: params
            });
        },

        getItem: (data: RequestData) => {
            const url = `${getUrl()}/${getPropByString(data, "params.id")}`;
            return HttpRequest.get(url);
        },

        update: (data: RequestData) => {
            const method = "patch"// data.patch ? 'patch' : 'put';
            const url = `${getUrl()}/${getPropByString(data, "params.id")}`;
            return HttpRequest[method](url, data.payload, {});
        }
    };
}

export default api();
